import { render } from "./templates.vue?vue&type=template&id=b24c4084"
import script from "./templates.vue?vue&type=script&lang=js"
export * from "./templates.vue?vue&type=script&lang=js"

import "./templates.vue?vue&type=style&index=0&id=b24c4084&lang=postcss"
script.render = render

export default script